module.exports = __webpack_public_path__ + "resources/img/img-acra-point-02.eed8a1db87f8bbe07f231409b6d24fdd.png";